"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
interface MemesLeaderboardDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
const MemesLeaderboardDropArtistInfo = t0 => {
  const $ = _c(27);
  const {
    drop
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author.handle || $[3] !== drop.author.primary_address) {
    t2 = drop.author.handle ? <UserProfileTooltipWrapper user={drop.author.handle}><Link href={`/${drop.author.handle}`} onClick={_temp} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{drop.author.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${drop.author.handle ?? drop.author.primary_address}`} onClick={_temp2} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{drop.author.handle}</span></Link>;
    $[2] = drop.author.handle;
    $[3] = drop.author.primary_address;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== drop.author.level) {
    t3 = !!drop.author.level && <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[5] = drop.author.level;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `leaderboard-author-badges-${drop.id}`;
  let t5;
  if ($[7] !== drop.author || $[8] !== t4) {
    t5 = <DropAuthorBadges profile={drop.author} tooltipIdPrefix={t4} />;
    $[7] = drop.author;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-text-sm tw-text-iron-500">•</span>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== drop.created_at) {
    t7 = <WaveDropTime timestamp={drop.created_at} />;
    $[11] = drop.created_at;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t5 || $[16] !== t7) {
    t8 = <div className="-tw-mt-0.5 tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1">{t2}{t3}{t5}{t6}{t7}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = drop.winning_context?.decision_time ?? null;
  let t10;
  if ($[18] !== drop.rank || $[19] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-x-2"><WinnerDropBadge rank={drop.rank} decisionTime={t9} /></div>;
    $[18] = drop.rank;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <div className="tw-flex tw-h-12 tw-flex-col tw-justify-between">{t8}{t10}</div>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t1 || $[25] !== t11) {
    t12 = <div className="tw-flex tw-gap-x-3">{t1}{t11}</div>;
    $[24] = t1;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
export default MemesLeaderboardDropArtistInfo;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}